/**
 * Meridian Watch — typed client for `/api/v1/workspaces/{id}/watch`.
 *
 * The Watch widget in the navbar polls this; one alert per row, with
 * an optional deep-link so the user can click straight to whatever
 * needs attention.
 */

import { api } from "./api";

export type WatchSeverity = "warning" | "info";

export interface WatchAlert {
  id: string;
  severity: WatchSeverity;
  title: string;
  detail: string;
  link: string | null;
  detected_at: string;
}

export interface WatchResponse {
  alerts: WatchAlert[];
}

export function fetchWatchAlerts(workspaceId: string): Promise<WatchResponse> {
  return api<WatchResponse>(`/api/v1/workspaces/${workspaceId}/watch`);
}
